<template>
    <div class="likingTable">
        <h4 v-if="title">{{title}}</h4>
        <table>
            <tr v-for="item in kItems" :key="item.id">
                <td style="vertical-align:top">
                    {{item.name?item.name:item.title}}
                </td>
                <td>
                    <link-options :item-id="item.id" :type="type" />
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import LinkOptions from "./LinkOptions.vue";
export default {
    name: "ResourceLinkingTable",
    components: {
        LinkOptions
    },
    props: {
        title: String,
        kItems: Array,
        type: String
    },
    
}
</script>
<style scoped>
.likingTable table {
    width: 100%;
    text-align: left;
    margin-bottom: 20px;
}
td {
    width: 50%;
    padding-left: 20px;
}
h4 {
  font-size: 1.2rem;
  font-weight: bold;  
  background-color: #ccc
}
</style>